import type { GroundReading } from "../ground/view.ts";

/**
 * The ground items the scene draws, as world-attached UI reads them (P2.8-T76): each one's handle, item, name, rarity,
 * look and point in world pixels, as the ground view last placed them (`ground/view.ts`). The list is a new array each
 * time the items are placed again and the same array between, so a surface can tell a change by the array alone.
 * Reading it allocates nothing.
 */
export interface GroundSource {
  /**
   * The items drawn now.
   *
   * @returns The ground view's readings, or an empty list before the world has loaded.
   */
  readings(): readonly GroundReading[];
}

/**
 * The list of a scene that draws no ground items, the same array each time.
 */
const NONE: readonly GroundReading[] = Object.freeze([]);

/**
 * The source of a scene that draws no ground items, as the `/ui` gallery's pages.
 */
export const NO_GROUND: GroundSource = Object.freeze({
  /**
   * Draws no item.
   *
   * @returns An empty list, the same each time.
   */
  readings: (): readonly GroundReading[] => NONE,
});
